module.exports = __webpack_public_path__ + "static/img/wxts.b249db9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wxts.png
// module id = IT/d
// module chunks = 128